import { useQuery } from '@tanstack/react-query';
import { getAssetPrices } from '../requests';
import { CACHE_TIME_5_MINUTES } from '@/shared/config';
import type { AssetPricesFilter } from '@/shared/types';

interface UseAssetPricesOptions {
  asset: string;
  filter?: AssetPricesFilter;
  enabled?: boolean;
  staleTime?: number;
  gcTime?: number;
}

export function useAssetPrices({
  asset,
  filter,
  enabled = true,
  staleTime = 1000 * 60,
  gcTime = CACHE_TIME_5_MINUTES,
}: UseAssetPricesOptions) {
  const query = useQuery({
    queryKey: ['asset-prices', asset, filter ?? null],
    queryFn: async () => {
      return await getAssetPrices(asset, filter);
    },
    enabled: enabled && !!asset,
    staleTime,
    gcTime,
    refetchInterval: data =>
      data.state.data?.autoRefreshAssetsPricesTime ?? false,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
